import { Input, Button, Card, Form, Typography } from 'antd';
import { useState } from 'react';

import notifier from 'utils/notifier';
import { ErrorResponse } from 'utils/types';
import moment from 'moment';
import { isEmailAddressValid } from 'utils/helpers';

import FloatLabel from 'components/Common/FloatLabel';

import './index.scss';

type UserProfileProps = {
  update(userModel: Object): any,
  isUpdating: boolean,
};

const UserProfile = (props: UserProfileProps) => {
  const [form] = Form.useForm();
  const { Title } = Typography;
  const IS_SIX_MONTH_DIFF = moment().diff(moment(sessionStorage.getItem('modified_date')), 'months', true) > 6 ? true : false;
  const EMAIL = isEmailAddressValid(sessionStorage.getItem('email'));

  const [showVerifyWarning, setShowVerifyWarning] = useState(IS_SIX_MONTH_DIFF || !EMAIL);

  const submit = () => {
    form.validateFields().then((values: any) => {
      const formData = {
        RmiEmail: values.emailAddress,
        RmiFirstName: sessionStorage.firstName,
        RmiLastName: sessionStorage.lastName,
        RmiUserId: sessionStorage.user_id,
      };

      props.update(formData)
        .then((response: Date) => {
          if (response) {
            sessionStorage.setItem('email', values.emailAddress);
            sessionStorage.setItem('modified_date', response.toString());
            setShowVerifyWarning(false);
            notifier.success('Successfully updated profile information.');
          } else {
            notifier.error('Profile update unsuccessful.');
          }
        })
        .catch((err: ErrorResponse) => {
          notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
        });
      }).catch((errorInfo: any) => {
        notifier.error(`Form was not submitted.`, 'Please check for errors and try again.');
      });
  };

  return (
    <>
      {showVerifyWarning ? <Title style={{textAlign: 'center', color: 'red'}}level={4}>It's time to update and verify your account information! Please add or update your information to continue using the portal</Title> : null}
      <div className="profile-page">
        <Card className="profile-form">
            <div className="col-lg mb-2">
              <b>
                First Name:
              </b>
              <br />
                <p className="profile-name">{sessionStorage.firstName}</p>
            </div>
            <div className="col-lg mb-2">
              <b>
                Last Name/ Vendor:
              </b>
              <br />
                <p className="profile-name">{sessionStorage.lastName ? sessionStorage.lastName : <br />}</p>
            </div>
            <Form
              form={form}
              name="update-profile"
              onFinish={submit}
              initialValues={{
                emailAddress: sessionStorage.email === 'null' ? '' : sessionStorage.email
              }}
            >
              <FloatLabel
                name="emailAddress"
                label="Email Address"
                form={form}
                required
                rules={[
                  () => ({
                    validator(_: any, value: string) {
                      if (value && !value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                        return Promise.reject('Please enter a valid email address.');
                      }
                      return Promise.resolve();
                    }
                  })
                ]}
              >
                <Input />
              </FloatLabel>
            </Form>
            <div className="btn-wrapper d-flex justify-content-end">
              <Button type="primary" onClick={submit} loading={props.isUpdating}>Submit</Button>
              <Button type="default" onClick={() => form.resetFields()}>Reset</Button>
            </div>
        </Card>
      </div>
    </>
  );
};

export default UserProfile;